export default __webpack_public_path__ + "static/media/d-la-costa.13c71ebf.jpg";